<template>
  <div>
    <!-- 基数管理 -->
    <div class="serach">
      <label class="ml10">器械包名称:</label>
      <el-select
        class="input200 ml10"
        clearable
        filterable
        remote
        :remote-method="
          (query) => {
            getPackage(query)
          }
        "
        v-model="queryParams.package_name"
      >
        <el-option
          v-for="(item, index) in packageList"
          :key="index"
          :value="item.name"
          :label="item.name"
        ></el-option>
      </el-select>

      <label class="ml10">科室:</label>
      <el-select
        class="input200 ml10"
        clearable
        filterable
        v-model="queryParams.department_id"
      >
        <el-option
          v-for="(item, index) in departmentList"
          :key="index"
          :value="item.id"
          :label="item.name"
        ></el-option>
      </el-select>

      <el-checkbox class="ml10" v-model="queryParams.is_hidden_zero">屏蔽基数0</el-checkbox>
      <el-button type="primary" size="mini" class="ml10" @click="getList"
        >查询</el-button
      >
    </div>
    <div class="vux_table pl0 mt10">
      <el-table
        border
        stripe
        id="toolbar_demo3"
        :data="tableData"
        align="center"
        :auto-resize="true"
        highlight-hover-row
      >
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :label="item.label"
          :prop="item.column"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="item.prop == 'handle'">
              <el-button v-if="(user.department_data.type === 1 && scope.row.can_edit) || (user.department_data.id === scope.row.department_id && btnauth[$route.path].includes('cardinal_updata_button')) " @click="edit(scope.row)" type="primary" size="mini">修改</el-button>
            </div>

            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
    <el-dialog
      title="修改"
      :visible.sync="editShow"
      width="30%"
    >
      <div class="mb10">
        <label class="ml10">包名:</label>
        <el-tag class="ml10">{{ editData.instrumentset_name }}</el-tag>
      </div>
      <div class="mb10">
        <label class="ml10">科室名:</label>
        <el-tag class="ml10">{{ editData.department_name }}</el-tag>
      </div>
      <div>
        <label class="ml10">基数:</label>
        <el-input-number class="ml10" v-model="editData.number"></el-input-number>
      </div>
      

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
        <el-button size="mini" @click="result">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { pageSize } from '@/utils/Config'
import Pagination from '@/components/common/Pagination'
import {
  cardinalList,
  cardinalEdit,
  cardinalBase,
  userDepartmentsAll,
} from '@/api.js'
export default {
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0,
      },
      packageList: [],
      departmentList: [],
      tableData: [],
      columns: [],
      editShow: false,
      editData: {},
    }
  },
  created() {
    this.getList()
    this.getPackage()
    this.getDepartment()
  },
  computed: {
      ...mapGetters(['user', 'btnauth'])
  },
  components: {
    Pagination,
  },
  methods: {
    getList() {
      const {
        package_name,
        department_id,
        is_hidden_zero,
        pageIndex,
        pageSize,
      } = this.queryParams
      const query = {
        package_name,
        department_id,
        page: pageIndex,
        per_page: pageSize,
      }
      if (is_hidden_zero) {
        query.is_hidden_zero = 1
      }
      this.$request('get', cardinalList, query).then((res) => {
        this.tableData = res.data
        this.columns = this.$utils.generateColumns(res.columns)
        this.queryParams._total = res.total

        // 手动添加操作栏
        this.columns.push({
          label: '操作',
          prop: 'handle',
        })
      })
    },
    getPackage(query = '') {
      this.$request('get', cardinalBase, { name: query }).then((res) => {
        this.packageList = res
      })
    },
    getDepartment() {
      this.$request('get', userDepartmentsAll, {}).then((res) => {
        this.departmentList = res
      })
    },
    edit(row) {
      this.editData = row
      this.editShow = true
    },
    result() {
      this.editData = {}
      this.editShow = false
    },
    submit() {
      const query = {
        department_id: this.editData.department_id,
        instrumentset_id: this.editData.instrumentset_id,
        id: this.editData.id,
        number: this.editData.number,
      }
      this.$request('post', cardinalEdit, query)
      .then((res) => {
        if (res) {
          this.editData = {}
          this.editShow = false
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped></style>
